import { BaseDevice, CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/nd63/list_icon.png'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_PRO } from '../../light/light_effect_list'
import { nd63VKCodes } from '../keycode/vkeycode'
import { generateArray } from '@/tool/utility'
import { getDeviceKeySquare } from '../keysquare/keysquare'

export class ND63 extends BaseDevice {
  y_number: number = 0
  //fn层不可选kk
  square = getDeviceKeySquare(DevicePid.IROKNd63)
  name: string = 'ND63'
  icon: string = list_icon
  width: number = 634
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO

  inoperableKeys: KK[] = [0x01]
  fnDisableKeys: KK[] = [0x15, 0x17, 0xe3, 0x52, 0x50, 0x51, 0x4f, 0x29, 0x1e, 0x1f, 0x20, 0x21, 0x22, 0x23, 0x24, 0x25, 0x26, 0x27, 0x2d, 0x2e, 0xe6]
  customLayout: CustomLayout = {
    0x2a: this.createSquare(2, 2, 74),
    0x2b: this.createSquare(2, 2, 58),
    0x31: this.createSquare(2, 2, 56),
    0x39: this.createSquare(2, 2, 67),
    0x28: this.createSquare(2, 2, 88),
    0xe1: this.createSquare(2, 2, 74),
    0xe0: this.createSquare(2, 2, 50),
    0xe2: this.createSquare(2, 2, 50),
    0xe3: this.createSquare(2, 2, 50),
    0x2c: this.createSquare(2, 2, 250),
  }
  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = true
  vkcodes = nd63VKCodes
  magneticAxis: boolean = true
  speedAllowValues: number[] = generateArray(0, 5)
  lightAllowValues: number[] = generateArray(0, 5)

  minDelayTimer: number = 1
  maxDelayTimer: number = 60000
}
